export const PAYPAL_PRODUCT_BUTTON = '.paypal-product__btn button';
